"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _semanticUiReact = require("semantic-ui-react");
var _reactRedux = require("react-redux");
var _uuid = require("uuid");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireWildcard(require("../../../../ui/Button"));
var _actions = require("../../store/actions");
var _selectors = require("../../store/selectors");
var _hooks = require("../../hooks");
var _plus = _interopRequireDefault(require("../../icons/plus.svg"));
var _styles = _interopRequireDefault(require("../../styles.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var INDICATORS_KEY = (0, _uuid.v4)();
var indicatorsSelector = R.partialRight((0, _selectors.getSavingClaimIndicatorsByKey)(), [{
  indicatorsKey: INDICATORS_KEY
}]);
var AddNewClaimAndClientButton = function AddNewClaimAndClientButton(_ref) {
  var _onClick = _ref.onClick;
  var _useTranslation = (0, _reactI18next.useTranslation)('SAVE_TO_CLAIM_MODAL'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var indicators = (0, _reactRedux.useSelector)(indicatorsSelector);
  var callbacks = (0, _hooks.useCallbacksForSave)(INDICATORS_KEY);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: (0, _classnames.default)(_styles.default.button, _styles.default.largeAddItemButton),
    disabled: indicators.loading,
    icon: _plus.default,
    iconClassName: _styles.default.plusIcon,
    theme: _Button.THEMES.GRAY,
    onClick: function onClick() {
      return _onClick({
        callbacks: callbacks
      });
    }
  }, t('ADD_NEW_CLAIM_AND_CLIENT_BUTTON')), indicators.error && /*#__PURE__*/_react.default.createElement(_semanticUiReact.Message, {
    error: true,
    icon: true,
    visible: true,
    header: indicators.error.message,
    onDismiss: function onDismiss() {
      return dispatch((0, _actions.clearSavingClaimIndicators)(INDICATORS_KEY));
    }
  }));
};
AddNewClaimAndClientButton.propTypes = {
  onClick: _propTypes.default.func.isRequired
};
var _default = exports.default = (0, _react.memo)(AddNewClaimAndClientButton);